var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 1L7.82478 0.525658C7.72215 0.491447 7.61119 0.491447 7.50855 0.525658L7.66667 1ZM4.33333 11L4.17522 11.4743C4.27785 11.5086 4.38881 11.5086 4.49145 11.4743L4.33333 11ZM1 1L1.15811 0.525658C1.00564 0.474834 0.838029 0.500403 0.707645 0.594379C0.577261 0.688355 0.5 0.839278 0.5 1H1ZM11 2.11111H11.5C11.5 1.8959 11.3623 1.70483 11.1581 1.63677L11 2.11111ZM11 11L10.8419 11.4743C10.9944 11.5252 11.162 11.4996 11.2924 11.4056C11.4227 11.3116 11.5 11.1607 11.5 11H11ZM1 9.88889H0.5C0.5 10.1041 0.637715 10.2952 0.841886 10.3632L1 9.88889ZM7.16667 1V9.88889H8.16667V1H7.16667ZM3.83333 2.11111V11H4.83333V2.11111H3.83333ZM4.49145 1.63677L1.15811 0.525658L0.841886 1.47434L4.17522 2.58545L4.49145 1.63677ZM7.50855 0.525658L4.17522 1.63677L4.49145 2.58545L7.82478 1.47434L7.50855 0.525658ZM7.50855 1.47434L10.8419 2.58545L11.1581 1.63677L7.82478 0.525658L7.50855 1.47434ZM10.5 2.11111V11H11.5V2.11111H10.5ZM11.1581 10.5257L7.82478 9.41455L7.50855 10.3632L10.8419 11.4743L11.1581 10.5257ZM4.49145 11.4743L7.82478 10.3632L7.50855 9.41455L4.17522 10.5257L4.49145 11.4743ZM0.841886 10.3632L4.17522 11.4743L4.49145 10.5257L1.15811 9.41455L0.841886 10.3632ZM0.5 1V9.88889H1.5V1H0.5Z",
    fill: "#FFBC11"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.953f78b8ed84a397cce3cfc75e294728.svg";
export { ForwardRef as ReactComponent };